import { createSignal, createEffect, onMount } from "solid-js";

export default function VerificationCode(props) {
  const [digits, setDigits] = createSignal(Array(6).fill(""));
  const [currentIndex, setCurrentIndex] = createSignal(0);
  let inputs = [];

  createEffect(() => {
    props.resetCount; // depend on it
    setDigits(Array(6).fill(""));
    setCurrentIndex(0);
    queueMicrotask(() => inputs[0]?.focus());
  });

  const handleInput = (e, index) => {
    const val = e.target.value;

    // Only accept exactly one digit (0-9)
    if (!/^\d$/.test(val)) {
      // Revert to previous value and keep focus
      e.target.value = digits()[index];
      queueMicrotask(() => inputs[index]?.focus());
      return;
    }

    const newDigits = [...digits()];
    newDigits[index] = val;
    setDigits(newDigits);

    if (index < 5) {
      setCurrentIndex(index + 1);
      queueMicrotask(() => inputs[index + 1]?.focus());
    } else {
      props.onComplete?.(newDigits.join(""));
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const currentDigits = [...digits()];

      if (currentDigits[index]) {
        // Clear current
        currentDigits[index] = "";
        setDigits(currentDigits);
        setCurrentIndex(index);
        queueMicrotask(() => inputs[index]?.focus());
      } else if (index > 0) {
        // Move back and clear
        currentDigits[index - 1] = "";
        setDigits(currentDigits);
        setCurrentIndex(index - 1);
        queueMicrotask(() => inputs[index - 1]?.focus());
      }
    } else if (e.key.length === 1 && !/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  onMount(() => {
    setCurrentIndex(0);
    inputs[0]?.focus();

    // Keep focus within inputs on outside clicks
    window.addEventListener("mousedown", (e) => {
      if (!inputs.includes(e.target)) {
        queueMicrotask(() => inputs[currentIndex()]?.focus());
      }
    });
  });

  return (
    <div class="six-digit-div">
      {digits().map((_, i) => (
        <input
          class="two-factor-input"
          ref={(el) => (inputs[i] = el)}
          type="text"
          inputMode="numeric"
          pattern="\d*"
          maxLength={1}
          value={digits()[i]}
          onInput={(e) => handleInput(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          onFocus={() => setCurrentIndex(i)}
          onPaste={(e) => e.preventDefault()}
        />
      ))}
    </div>
  );
}
